export default class Form {
	
	constructor(questions, databases, pages) {		
		this.jsonTransform = questions;
		this.databases = databases;
		this.pages = pages;
		this.structure = {
			name: '',
			type: '',
			label: '',
			required: true,
			inputType: '',
			options: [],
			content: '',
			inherited: [],
			maxLength: 0,
			data: [],
			properties: {},
			query: {},
			help: '',
			related:{}
		}		
	}

	getQuestions() {	
		const newForm = [];
		const related = {};
		for(var i in this.jsonTransform) {
			const result = this.getQuestion(this.jsonTransform[i]);
			if(result.help) newForm.push(result);
			else {
				result.help = '';
				newForm.push(result);
			}			
		}			
		return newForm;		
	}

	getQuestion(question) {
		let newObject = {...question};
		for(var j in this.structure) {			
			if(newObject.hasOwnProperty(j)) {
				if(j === 'inputType') {
					if(newObject[j] !== 'flex') {
						delete newObject.related;
					}
				}  

				if(j === 'type' && newObject[j] === "datasource") {
					if(newObject.properties.originKey === '_is_Null_Origin_Key_') {
						newObject.properties.originKey = "";
						newObject.properties.searchField = "";
						newObject.data = [];
					}					
				}
			}
		}
		return newObject;
	}

	getSimple() {
		let objetRelated = {};
		let dependencias = [];
		const related = this.jsonTransform.filter(question => question.related)
										  .filter(question => question.related.relatedness !== 'listener' && question.inputType !== 'flex' && question.related.relatedness !== 'compound');										  
		for(var i in related) {
			let question = related[i];
			dependencias.push(question.name);
			if(objetRelated[question.related.name]) {
				const object = {
					[question.name] : question.related
				}
				objetRelated[question.related.name] = {...objetRelated[question.related.name], ...object}
			}else {
				objetRelated[question.related.name] = {
					[question.name] : question.related
				}
			}
		}		
		return {objetRelated, dependencias};
	}

	getCompound() {
		let objetCompound = {};
		let dependencias = [];
		const relatedCompound = this.jsonTransform.filter(question => question.related)
										  .filter(question => question.related.relatedness === 'compound');

		for(var i in relatedCompound) {
			let question = relatedCompound[i];
			objetCompound[question.name] = question.related;
			dependencias.push(question.name);
		}
		return {objetCompound, dependencias};
	}

	getListener() {
		let objetListener = {};
		const relatedListener = this.jsonTransform.filter(question => question.related)
										  .filter(question => question.related.relatedness === 'listener');

		for(var i in relatedListener) {
			let question = relatedListener[i];
			let related = {
				related: question.related
			}
			objetListener[question.name] = related;
		}

		return objetListener;
	}

	getColumnsSelect() {
		let columns = {};
		const originSelect = this.jsonTransform.filter(question => question.inputType === 'select')
											 .filter(question => question.query.action !== 'trigger');

		for(var i in originSelect) {
			let question = originSelect[i];

			for(var j in this.databases) {
				if(this.databases[j].question === question.name) {
					columns[question.name] = this.databases[j].columns;
					break;
				}
			}			
		}

		return columns;
	}

	getPages() {
		let begin = 0;
		let arrayPages = [];
		const getQuestionsFormater = this.getQuestions();
		for(var i in this.pages) {
			let end = this.pages[i].end;
			let page = getQuestionsFormater.slice(begin, end + 1);
			arrayPages.push(page);
			begin = this.pages[i].end + 1;
		}
		return arrayPages;
	}
}